import { PAGE_DATA_ACTIONS } from "./action";

// ----------------------------------------------------------------------

const pageDataInitialState = {
  data: [],
  pageData: {},
  loading: false,
  pagination: {
    currentPage: 0,
    totalPages: 1,
    perPage: 1,
    total: 1,
  },
};

// eslint-disable-next-line default-param-last
export function pageDataReducer(state = pageDataInitialState, action) {
  switch (action.type) {
    case PAGE_DATA_ACTIONS.SET_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
